import { render, staticRenderFns } from "./ktgl-learning-entry.vue?vue&type=template&id=6a177676"
import script from "./ktgl-learning-entry.vue?vue&type=script&lang=ts"
export * from "./ktgl-learning-entry.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports